import { render, staticRenderFns } from "./GroupAmountModal.vue?vue&type=template&id=384dd024&scoped=true&"
import script from "./GroupAmountModal.vue?vue&type=script&lang=js&"
export * from "./GroupAmountModal.vue?vue&type=script&lang=js&"
import style0 from "./GroupAmountModal.vue?vue&type=style&index=0&id=384dd024&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384dd024",
  null
  
)

export default component.exports